(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    var selects = form.querySelectorAll('[data-option-index]');
    if (!jsonEl || !selects.length) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('button[type="submit"]');
    var scope = form.closest('[data-product]') || document;
    var priceEl = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare]');
    var currency = form.getAttribute('data-currency');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!variant) {
        button.disabled = true;
        button.textContent = 'Not available';
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.getAttribute('data-label') : (button.getAttribute('data-soon') || 'Coming Soon!');
      if (priceEl) priceEl.textContent = money(variant.price, currency);
      if (compareEl) compareEl.hidden = !(variant.compare_at_price > variant.price);
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
})();
